import { controls } from "../../controls";

const rp818 = {
  label: "I Form Register",
  pageLabel: "I Form Register",
  starting: true,
  url: "rp818",

  pageType: "history",
  filter: [


    ...controls.displayText({ tab: "filter", label: "As On Date", width: "col-sm-2 " }),
    ...controls.magicDate({ tab: "filter", name: "as_on_date", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-6 " }),

    ...controls.checkBox({ tab: "filter", label: "Print Area", name: "print_area", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "Member Type", width: "col-sm-2" }),
    ...controls.select({
      tab: "filter", name: "select", width: "col-sm-2", placeHolder: "Select", defaultValue: "",
      options: [{
        label: "Regular",
        value: "regular"
      },
      {
        label: "Associated",
        value: "associated"
      },
      {
        label: "Nominal (B-Class)",
        value: "nominal"
      }]
    }),

    ...controls.displayText({ tab: "filter", label: "State", width: "col-sm-1" }),
    ...controls.State({ tab: "filter" }),
    ...controls.showData({ tab: "filter", data: "state_display", name: "state_display", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-1 " }),

    ...controls.checkBox({ tab: "filter", label: "Print Address", name: "print_address", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "Member Number From-To", width: "col-sm-2" }),
    ...controls.numberOnly({ tab: "filter", name: "member_number_from", width: "col-sm-1" }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-0" }),
    ...controls.numberOnly({ tab: "filter", name: "member_number_to", width: "col-sm-1" }),

    ...controls.displayText({ tab: "filter", label: "District", width: "col-sm-1" }),
    ...controls.District({ tab: "filter" }),
    ...controls.showData({ tab: "filter", data: "district_display", name: "district_display", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-1 " }),

    ...controls.checkBox({ tab: "filter", label: "Print State", name: "print_state", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "Opening Date From-To", width: "col-sm-2 " }),
    ...controls.magicDate({ tab: "filter", name: "opening_date_from", width: "col-sm-1" }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-0 " }),
    ...controls.magicDate({ tab: "filter", name: "opening_date_to", width: "col-sm-1" }),

    ...controls.displayText({ tab: "filter", label: "Taluka", width: "col-sm-1" }),
    ...controls.Taluka({ tab: "filter" }),
    ...controls.showData({ tab: "filter", data: "taluka_display", name: "taluka_display", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-1 " }),

    ...controls.checkBox({ tab: "filter", label: "Print District", name: "print_district", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "Amount From-To", width: "col-sm-2" }),
    ...controls.numberOnly({ tab: "filter", name: "amount_from", width: "col-sm-1" }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-0" }),
    ...controls.numberOnly({ tab: "filter", name: "amount_to", width: "col-sm-1" }),

    ...controls.displayText({ tab: "filter", label: "Village", width: "col-sm-1" }),
    ...controls.Village({ tab: "filter" }),
    ...controls.showData({ tab: "filter", data: "village_display", name: "village_display", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-1 " }),

    ...controls.checkBox({ tab: "filter", label: "Print Taluka", name: "print_taluka", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "Account Type", width: "col-sm-2 " }),
    ...controls.AccountType({ tab: "filter", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "Area", width: "col-sm-1" }),
    ...controls.Area({ tab: "filter" }),
    ...controls.showData({ tab: "filter", data: "area_display", name: "area_display", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-1 " }),

    ...controls.checkBox({ tab: "filter", label: "Print Villlage", name: "print_villlage", width: "col-sm-2" }),


    ...controls.displayText({ tab: "filter", label: "Divident Transfer To", width: "col-sm-2" }),
    ...controls.select({
      tab: "filter", name: "select", width: "col-sm-2", placeHolder: "Select", defaultValue: "",
      options: [{
        label: "Having A/C No.",
        value: "having_acctcode"
      },
      {
        label: "Having Active A/C No.",
        value: "having_active_acctcode"
      },
      {
        label: "Not Having A/C No.",
        value: "not_having_acctcode"
      }]
    }),

    ...controls.displayText({ tab: "filter", label: "A/C in Branch", width: "col-sm-1" }),
    ...controls.branch({ tab: "filter", defaultValue: "assigned_branch" }),
    ...controls.showData({ tab: "filter", data: "branch_display", name: "branch_display", width: "col-sm-2", displaytype: 'small' }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-1 " }),

    ...controls.checkBox({ tab: "filter", label: "Print A/C No", name: "print_acctcode", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "Gender", width: "col-sm-2" }),
    ...controls.select({
      tab: "filter", name: "select", width: "col-sm-2", placeHolder: "Select", defaultValue: "",
      options: [{
        label: "Male",
        value: "male"
      },
      {
        label: "Female",
        value: "female"
      },
      {
        label: "Not Applicable",
        value: "not_applicable"
      }]
    }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-4 " }),

    ...controls.checkBox({ tab: "filter", label: "Regional Name", name: "regional_name", width: "col-sm-2" }),

    ...controls.checkBox({ tab: "filter", label: "Print Mobile Of A/C", name: "print_mobile", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "Member from Branch", width: "col-sm-2" }),
    ...controls.branch({ tab: "filter", defaultValue: "assigned_branch" }),
    ...controls.showData({ tab: "filter", data: "branch_display", name: "branch_display", width: "col-sm-2", displaytype: 'small' }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2 " }),

    ...controls.checkBox({ tab: "filter", label: "Without Name", name: "without_name", width: "col-sm-2" }),

    ...controls.checkBox({ tab: "filter", label: "Print CIN", name: "print_cin", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "# Records", width: "col-sm-2" }),
    ...controls.perPage({ tab: 'filter' }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-4 " }),

    ...controls.checkBox({ tab: "filter", label: "Print Nominee", name: "print_nominee", width: "col-sm-2" }),


    ...controls.checkBox({ tab: "filter", label: "Detail", name: "detail", width: "col-sm-2" }),


  ],

  form: [],

  history: {
    perPage: 10,
    reportHeader: "I Form Register",
    pdfProps: { pageSize: "A4", pageOrientation: "landscape" },
    displayColumns: [
      {
        Header: "Sr",
        type: "autoinc",
        accessor: "srno",
        width: 30
      },
      {
        Header: "Member No",
        accessor: "member_no"

      },

      {
        Header: "Member Name",
        accessor: "member_name",

      },

      {
        Header: "No Of Shares",
        accessor: "no_of_shares",

      },


      {
        Header: "Balance",
        accessor: "balance",
        type: "currency"
      },

      {
        Header: "Dividend",
        accessor: "dividend",
        type: "currency"
      },
      {
        Header: "Div Total",
        accessor: "div_total",
        type: "currency"
      },

      {
        Header: "Area",
        accessor: "area",

      },

      {
        Header: "Mobile Of A/C",
        accessor: "mobil_of_a/c",

      },

      {
        Header: "Nomini Name",
        accessor: "nomini_name",

      },

      {
        Header: "Nomini Address",
        accessor: "nomini_address",

      },

      {
        Header: "State",
        accessor: "state",

      },

      {
        Header: "District",
        accessor: "district",

      },

      {
        Header: "Taluka",
        accessor: "taluka",

      },

      {
        Header: "Village",
        accessor: "village",

      },

    ]
  }
};

export default rp818;